import { LoadingPage, TitledLoadingPage } from 'cleveron-web-components';
import React from 'react';

const LoadingComponent = React.memo(function LoadingComponent({
    hasBackButton,
    id,
    tabs,
    titleKey,
}) {
    if (titleKey) {
        return (
            <TitledLoadingPage
                hasBackButton={hasBackButton}
                id={`${id}TitledLoadingPage`}
                tabs={tabs}
                titleKey={titleKey}
            />
        );
    }
    return <LoadingPage id={`${id}LoadingPage`} />;
});

export default LoadingComponent;
